import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	let arr = []

	const hasBeneficiary = !(
		injured.beneficiary &&
		['0', ''].includes(injured.beneficiary.hasBeneficiary)
	)

	if (hasBeneficiary) {
		let list = [{}]
		if (injured.beneficiary && injured.beneficiary.beneficiaryList.length) {
			list = injured.beneficiary.beneficiaryList
		}

		for (const item of list) {
			let beneficiaryInfoArr = []
			beneficiaryInfoArr.push(
				{
					label: '人员类型',
					value: setting.beneficiarytypeMap[item.beneficiaryType],
				},
				{
					label: '姓名',
					value: item.name,
				},
				{
					label: '证件类型',
					value: setting.idTypeMap[item.certificateType],
				},
				{
					label: '证件号',
					value: item.certificateNo,
				},
				{
					label: '年龄',
					value: item.age,
				},
				{
					label: '联系电话',
					value: item.phone,
				}
			)
			arr.push(beneficiaryInfoArr)
		}
	}

	const obj = {
		title: '监护/受益人信息',
		children: arr,
		show: {
			hasBeneficiary,
		},
	}

	return obj
}
